import { useDispatch, useSelector } from "react-redux";
import { getGroups, getSingleSensor, updateSensor } from "../../Api Methods/Api";
import { Await, useLoaderData, useNavigate } from "react-router-dom";
import Stats2 from "../../components/UI/Stats/Stats2";
import classes from "./sensorEntity.module.css";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import DataManager from "../../hooks/DataManager";

// TODO: replace these stubs with real API imports when endpoints are ready
// const getSingleSensorEvents = async (_apiData, _sensorID) => ({ success: false, data: [] });


const SensorEntity = () => {
    console.log("called");

    const sensor = useLoaderData();

    console.log(sensor);

    const [localSensor, setLocalSensor] = useState(sensor);
    const companyName = useSelector(state => state.auth.companyName);
    const role = useSelector(state => state.auth.role);
    const isAllowed = companyName === "EyeSpyFX" || companyName === "KNOWIO";
    const isCustomerBillingAllowed = companyName === "EyeSpyFX" || companyName === "RE:SURE";
    const [unauthotisedClick, setUnauthorisedClick] = useState(false);

    const dataManager = new DataManager();
    const [sensorEvents, setSensorEvents] = useState([]);
    const [showLoading, setShowLoading] = useState(true);
    const dispatch = useDispatch();
    const [groups, setGroups] = useState([]);
    const token = localStorage?.getItem("token");
    const client = localStorage?.getItem("client");
    const apiData = { token, client };

    const [changeSensorName, setChangeSensorName] = useState(false);
    const [changeSerialNumber, setChangeSerialNumber] = useState(false);
    const [changeOwnedBy, setChangeOwnedBy] = useState(false);
    const [changeBillable, setChangeBillable] = useState(false);
    const [changeBilledTo, setChangeBilledTo] = useState(false);
    const [changeBillingFrequency, setChangeBillingFrequency] = useState(false);
    const [changeDateOfFirstInvoice, setChangeDateOfFirstInvoice] = useState(false);
    const [changeDateOfLastInvoice, setChangeDateOfLastInvoice] = useState(false);
    const [changeCustomerBilledTo, setChangeCustomerBilledTo] = useState(false);
    const [newCustomerBilledToGroupName, setNewCustomerBilledToGroupName] = useState(localSensor.customerBilledToGroupName || "");

    const [sensorName, setSensorName] = useState(localSensor.pinName);
    const [newSerialNumber, setNewSerialNumber] = useState(localSensor.serial || "");
    const [newOwnerGroupName, setNewOwnerGroupName] = useState(localSensor.ownedByGroupName || localSensor.name);
    const [newBilledToGroupName, setNewBilledToGroupName] = useState(localSensor.billedToGroupName || localSensor.name);
    const [newBillingFrequency, setNewBillingFrequency] = useState("");
    const [newDateOfFirstInvoice, setNewDateOfFirstInvoice] = useState("");
    const [newDateOfLastInvoice, setNewDateOfLastInvoice] = useState("");

    const [navigateToLinkedSite, setNavigateToLinkedSite] = useState(false);
    const [navigateToGroup, setNavigateToGroup] = useState(false);

    const billingOptions = ["Monthly", "Annually"];

    const toast = useRef(null);
    const navigate = useNavigate();

    const GetGroups = async () => {
        const data = await getGroups(apiData, dispatch);
        setGroups(data);
    };

    // const GetSensorEvents = async () => {
    //     const response = await getSingleSensorEvents(apiData, localSensor.deviceID);
    //     if (response.success) {
    //         setSensorEvents(response.data);
    //     }
    //     setShowLoading(false);
    // };

    const convertSensorType = (sensorType) => {
        switch (sensorType) {
            case 7: {
                return "BLE Sensor"
            }
            case 8: {
                return "Standalone NB-IoT Sensor"
            }
        }
    }

    useEffect(() => {
        //GetSensorEvents();
        GetGroups();
    }, []);

    useEffect(() => {
        if (navigateToLinkedSite) {
            navigate(`/Dashboard/SiteView/${localSensor.uuid}`);
        }
    }, [navigateToLinkedSite]);

    useEffect(() => {
        if (navigateToGroup) {
            const groupClicked = groups.find(g => g.name === localSensor.name);
            if (groupClicked) {
                sessionStorage.setItem("groupClicked", groupClicked.name);
                sessionStorage.setItem("groupPath", groupClicked.group_path);
                sessionStorage.setItem("groupClickedID", groupClicked.id);
                navigate("/Dashboard/Groups/GroupSites/");
            }
        }
    }, [navigateToGroup]);

    useEffect(() => {
        if (unauthotisedClick) {
            toast.current.show({
                severity: "error",
                summary: "Unauthorised",
                detail: "Please contact your administrator to update billing for this sensor",
                life: 3000,
            });
            setUnauthorisedClick(false);
        }
    }, [unauthotisedClick]);

    const UpdateSensorDetails = async (columnName, newValue) => {
        const body = {
            sensorID: localSensor.sensorID,
            columnName,
            newValue,
        };
        console.log(body);
        const response = await updateSensor(apiData, body, dispatch);
        if (response.success) {
            setLocalSensor(prev => ({ ...prev, [columnName]: newValue }));
        }
    };

    // Billable confirm / reject
    const accept = async () => {
        UpdateSensorDetails("billable", localSensor.billable == 1 ? 0 : 1);
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Billing status updated", life: 3000 });
    };
    const reject = () => {
        toast.current.show({ severity: "warn", summary: "Cancelled", detail: "Changes discarded", life: 3000 });
    };
    const defaultConfirmProps = {
        header: "Confirmation",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Yes",
        rejectLabel: "No",
        defaultFocus: "accept",
        accept,
        reject,
    };

    const updateSensorName = async () => {
        UpdateSensorDetails("pinName", sensorName);
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Sensor name updated", life: 3000 });
        setChangeSensorName(false);
    };

    const updateSerialNumber = async () => {
        UpdateSensorDetails("name", newSerialNumber);
        setLocalSensor(prev => ({ ...prev, serial: newSerialNumber }));
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Serial number updated", life: 3000 });
        setChangeSerialNumber(false);
    };

    const updateOwnedBy = async () => {
        const newOwnerID = groups.find(g => g.name === newOwnerGroupName)?.id;
        if (!newOwnerID) return;
        UpdateSensorDetails("ownedByGID", newOwnerID);
        setLocalSensor(prev => ({ ...prev, ownedByGroupName: newOwnerGroupName }));
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Owner updated", life: 3000 });
        setChangeOwnedBy(false);
    };

    const updateBilledTo = async () => {
        const newBilledToID = groups.find(g => g.name === newBilledToGroupName)?.id;
        if (!newBilledToID) return;
        UpdateSensorDetails("billedToGID", newBilledToID);
        setLocalSensor(prev => ({ ...prev, billedToGroupName: newBilledToGroupName }));
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Subscription updated", life: 3000 });
        setChangeBilledTo(false);
    };

    const updateCustomerBilledTo = async () => {
        const newCustomerBilledToID = groups.find(g => g.name === newCustomerBilledToGroupName)?.id;
        if (!newCustomerBilledToID) return;
        UpdateSensorDetails("customerBilledToGID", newCustomerBilledToID);
        setLocalSensor(prev => ({ ...prev, customerBilledToGroupName: newCustomerBilledToGroupName, customerBilledToGID: newCustomerBilledToID }));
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Customer billed to updated", life: 3000 });
        setChangeCustomerBilledTo(false);
    };

    const updateBillingFrequency = async () => {
        UpdateSensorDetails("billingFrequency", newBillingFrequency.toLowerCase());
        setLocalSensor(prev => ({ ...prev, billingFrequency: newBillingFrequency }));
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Billing frequency updated", life: 3000 });
        setChangeBillingFrequency(false);
    };

    const updateDateOfFirstInvoice = async () => {
        const formattedDate = newDateOfFirstInvoice ? format(newDateOfFirstInvoice, "yyyy-MM-dd") : "";
        UpdateSensorDetails("firstInvoiceDate", formattedDate);
        setLocalSensor(prev => ({ ...prev, firstInvoiceDate: formattedDate }));
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Invoice date updated", life: 3000 });
        setChangeDateOfFirstInvoice(false);
    };

    const updateDateOfLastInvoice = async () => {
        const formattedDate = newDateOfLastInvoice ? format(newDateOfLastInvoice, "yyyy-MM-dd") : "";
        UpdateSensorDetails("lastInvoiceDate", formattedDate);
        setLocalSensor(prev => ({ ...prev, lastInvoiceDate: formattedDate }));
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Invoice date updated", life: 3000 });
        setChangeDateOfLastInvoice(false);
    };

    const sensorTypeLabel = (type) => {
        switch (type) {
            case "SIGFOX RE:SURE": return "SigFox lite contact";
            case "IOTA": return "SigFox industrial contact";
            case 7: return "Standalone NB-IOT Sensor";
            case 8: return "BLE Sensor";
            default: return type || "Unknown";
        }
    };

    const convertGroupIDToName = (groupID) => {
        let group = groups.find(group => group.id == groupID)
        let groupName = ""
        if (group){
            groupName = group.name
        }
        return groupName
    }
    

    ///to get sensor events use userID 2582 and join devices to match up sensorID to event UUID

    return (
        <>
            <Toast ref={toast} />

            {/* ── Sensor name ── */}
            <Dialog
                header="Set sensor name"
                visible={changeSensorName}
                style={{ width: "50vw" }}
                onHide={() => setChangeSensorName(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <InputText
                        value={sensorName}
                        onChange={e => setSensorName(e.target.value)}
                        style={{ width: "100%", fontSize: "1rem" }}
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeSensorName(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateSensorName} />
                    </div>
                </div>
            </Dialog>

            {/* ── Serial number ── */}
            <Dialog
                header="Set serial number"
                visible={changeSerialNumber}
                style={{ width: "50vw" }}
                onHide={() => setChangeSerialNumber(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <InputText
                        value={newSerialNumber}
                        onChange={e => setNewSerialNumber(e.target.value)}
                        style={{ width: "100%", fontSize: "1rem" }}
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeSerialNumber(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateSerialNumber} />
                    </div>
                </div>
            </Dialog>

            {/* ── Billable confirm ── */}
            <ConfirmDialog
                visible={changeBillable}
                onHide={() => setChangeBillable(false)}
                {...defaultConfirmProps}
                message={`Are you sure you want to ${localSensor.billable == 0 ? "start" : "stop"} billing for this sensor?`}
            />

            {/* ── Owned by ── */}
            <Dialog
                header="Select new owner"
                visible={changeOwnedBy}
                style={{ width: "50vw", height: "20vw" }}
                onHide={() => setChangeOwnedBy(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Dropdown
                        placeholder={newOwnerGroupName}
                        options={groups.map(g => g.name).sort((a, b) => a.localeCompare(b))}
                        onChange={e => setNewOwnerGroupName(e.value)}
                        appendTo="self"
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeOwnedBy(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateOwnedBy} />
                    </div>
                </div>
            </Dialog>

            {/* ── Billed to ── */}
            <Dialog
                header="Select new purchasee"
                visible={changeBilledTo}
                style={{ width: "50vw", height: "20vw" }}
                onHide={() => setChangeBilledTo(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Dropdown
                        placeholder={newBilledToGroupName}
                        options={groups.map(g => g.name).sort((a, b) => a.localeCompare(b))}
                        onChange={e => setNewBilledToGroupName(e.value)}
                        appendTo="self"
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeBilledTo(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateBilledTo} />
                    </div>
                </div>
            </Dialog>

            {/* ── Customer billed to ── */}
            <Dialog
                header="Select customer billed to"
                visible={changeCustomerBilledTo}
                style={{ width: "50vw", height: "20vw" }}
                onHide={() => setChangeCustomerBilledTo(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Dropdown
                        placeholder={newCustomerBilledToGroupName || "Select group"}
                        options={groups.map(g => g.name).sort((a, b) => a.localeCompare(b))}
                        onChange={e => setNewCustomerBilledToGroupName(e.value)}
                        appendTo="self"
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeCustomerBilledTo(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateCustomerBilledTo} />
                    </div>
                </div>
            </Dialog>

            {/* ── Billing frequency ── */}
            <Dialog
                header="Select new billing frequency"
                visible={changeBillingFrequency}
                style={{ width: "30vw", height: "20vw" }}
                onHide={() => setChangeBillingFrequency(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Dropdown
                        placeholder={newBillingFrequency}
                        options={billingOptions}
                        onChange={e => setNewBillingFrequency(e.value)}
                    />
                </div>
                <br />
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                    <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeBillingFrequency(false)} className="p-button-secondary" />
                    <Button icon="pi pi-save" label="Save" onClick={updateBillingFrequency} />
                </div>
            </Dialog>

            {/* ── Date of hardware invoice ── */}
            <Dialog
                header="Set date of hardware invoice"
                visible={changeDateOfFirstInvoice}
                style={{ width: "30vw" }}
                onHide={() => setChangeDateOfFirstInvoice(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Calendar
                        value={newDateOfFirstInvoice}
                        onChange={e => setNewDateOfFirstInvoice(e.value)}
                        dateFormat="dd mm yy"
                        showIcon
                        inline
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeDateOfFirstInvoice(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateDateOfFirstInvoice} disabled={!newDateOfFirstInvoice} />
                    </div>
                </div>
            </Dialog>

            {/* ── Date of 1st SaaS invoice ── */}
            <Dialog
                header="Set date of 1st SaaS invoice"
                visible={changeDateOfLastInvoice}
                style={{ width: "30vw" }}
                onHide={() => setChangeDateOfLastInvoice(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Calendar
                        value={newDateOfLastInvoice}
                        onChange={e => setNewDateOfLastInvoice(e.value)}
                        dateFormat="dd mm yy"
                        showIcon
                        inline
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeDateOfLastInvoice(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateDateOfLastInvoice} disabled={!newDateOfLastInvoice} />
                    </div>
                </div>
            </Dialog>

            {/* ── Stat tiles ── */}
            <div className={classes.activtyPage_container}>
                <Await resolve={localSensor}>
                    {(loadedSensor) => (
                        <>
                        <div className={classes.container}>
                            <Stats2 title={"Sensor ID"} value={loadedSensor.sensorID} isLoadingStats={false} isStatic={true} />
                            {/* <Stats2 title={"Sensor name"} value={loadedSensor.pinName || "Not set"} isLoadingStats={false} isStatic={true} setChangeGatewayName={setChangeSensorName} editable={role === "admin" || role === "TechSupport"} /> */}
                            <Stats2 title={"Type"} value={sensorTypeLabel(loadedSensor.sensorType)} isLoadingStats={false} isStatic={true} />
                            {/* <Stats2 title={"Serial number"} value={loadedSensor.serial || "Not set"} isLoadingStats={false} isStatic={true} setShowChangeSerialNumber={setChangeSerialNumber} editable={role === "admin" || role === "TechSupport"} /> */}

                            {loadedSensor.uuid && (
                                <Stats2 title={"Linked to"} value={loadedSensor.tag || "Unlinked"} isLoadingStats={false} isStatic={true} setNavigateToLinkedSite={setNavigateToLinkedSite} />
                            )}

                            <Stats2 title={"Battery"} value={loadedSensor.battery && loadedSensor.battery !== "Not Read Yet" ? `${loadedSensor.battery}%` : "No data"} isLoadingStats={false} isStatic={true} />
                            <Stats2 title={"Signal"} value={loadedSensor.signal && loadedSensor.signal !== "Not Read Yet" ? `${loadedSensor.signal}%` : "No data"} isLoadingStats={false} isStatic={true} />

                            {loadedSensor.lastSeen && (
                                <Stats2 title={"Last updated"} value={format(new Date(loadedSensor.lastSeen), "MMM do, yyyy - HH:mm")} isLoadingStats={false} isStatic={true} />
                            )}

                            {loadedSensor.name && (
                                <Stats2 title={"Used by"} value={loadedSensor.name} isLoadingStats={false} isStatic={true} setNavigateToGroup={setNavigateToGroup}  editable={role === "admin" || role === "TechSupport"} />
                            )}

                            <Stats2
                                title={"Owned by"}
                                value={convertGroupIDToName(loadedSensor.ownedByGID) || "Not set"}
                                isLoadingStats={false}
                                isStatic={true}
                                setChangeOwnedBy={setChangeOwnedBy}
                                editable={isAllowed}
                            />

                            {isAllowed && (
                                <Stats2
                                    title={"Billable"}
                                    value={loadedSensor.billable == 1 ? "Yes" : "No"}
                                    isLoadingStats={false}
                                    isStatic={true}
                                    setChangeBillable={setChangeBillable}
                                    isAllowedToChange={isAllowed}
                                    setUnauthorisedClick={setUnauthorisedClick}
                                    editable={true}
                                />
                            )}

                            {(loadedSensor.billable == 1 && isAllowed) && (
                                <Stats2
                                    title={"Billed to"} //convert to group name!
                                    value={convertGroupIDToName(loadedSensor.billedToGID) || "Not set"}
                                    isLoadingStats={false}
                                    isStatic={true}
                                    setChangeBilledTo={setChangeBilledTo}
                                    isAllowedToChange={isAllowed}
                                    editable={isAllowed}
                                />
                            )}

                            {isAllowed && (
                                <Stats2
                                    title={"Billing frequency"}
                                    value={loadedSensor.billingFrequency ?? "Not set"}
                                    isLoadingStats={false}
                                    isStatic={true}
                                    setChangeBillingFrequency={setChangeBillingFrequency}
                                    isAllowedToChange={isAllowed}
                                    setUnauthorisedClick={setUnauthorisedClick}
                                    editable={true}
                                />
                            )}

                            {isAllowed && (
                                <Stats2
                                    title={"Date of hardware invoice"}
                                    value={loadedSensor.firstInvoiceDate ? format(new Date(loadedSensor.firstInvoiceDate), "dd/MM/yyyy") : "Not set"}
                                    isLoadingStats={false}
                                    isStatic={true}
                                    setChangeDateOfFirstInvoice={setChangeDateOfFirstInvoice}
                                    isAllowedToChange={isAllowed}
                                    setUnauthorisedClick={setUnauthorisedClick}
                                    editable={true}
                                />
                            )}

                            {isAllowed && (
                                <Stats2
                                    title={"Date of 1st SaaS invoice"}
                                    value={loadedSensor.lastInvoiceDate ? format(new Date(loadedSensor.lastInvoiceDate), "dd/MM/yyyy") : "Not set"}
                                    isLoadingStats={false}
                                    isStatic={true}
                                    setChangeDateOfLastInvoice={setChangeDateOfLastInvoice}
                                    isAllowedToChange={isAllowed}
                                    setUnauthorisedClick={setUnauthorisedClick}
                                    editable={true}
                                />
                            )}
                        </div>

                        {isCustomerBillingAllowed && <p style={{marginLeft:"2px", marginTop:"50px", fontWeight:"500", fontSize:"20px", color:"#808080"}}>Customer billing</p>}
                        {isCustomerBillingAllowed && (
                            <div className={classes.container}>
                                <Stats2
                                    title={"Billable:"}
                                    value={convertGroupIDToName(loadedSensor.customerBilledToGID) || "No"}
                                    status={""}
                                    isLoadingStats={false}
                                    isStatic={true}
                                    setChangeBilledTo={setChangeCustomerBilledTo}
                                    isAllowedToChange={true}
                                    editable={true}
                                />
                            </div>
                        )}
                        </>
                    )}
                </Await>
            </div>
        </>
    );
};

export default SensorEntity;

export async function sensorLoader({ params }) {
    const sensorID = params.SensorID;
    const token = localStorage?.getItem("token");
    const client = localStorage?.getItem("client");

    const sensor = await getSingleSensor({ token, client }, sensorID);
    console.log(sensor);
    return sensor[0];
}
